// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__-hash-base-64-5-","Open":"SideDrawer__Open__-hash-base-64-5-","Close":"SideDrawer__Close__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/SideDrawer/SideDrawer.scss
// module id = 149
// module chunks = 0